var React = require('react');

function Glasses (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#2185D0","strokeWidth":"10","d":"M114 21c0 37-20 60-52 60-31 0-50-21-56-64C49 1 83 1 108 17c3 3 37 3 40 0 25-16 59-16 102 0-6 43-25 64-56 64-32 0-52-23-52-60","key":1})]);
}

Glasses.defaultProps = {"viewBox":"0 0 256 86"};

module.exports = Glasses;

Glasses.default = Glasses;
